import { useEffect, useState } from "react";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { dealerSignal } from "../../../signal/dealerSignal";
import { Badge, Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Avatar from "react-avatar";
import * as moment from "moment";
import avatar1 from "../../../assets/images/avatars/01.png"
import { organisationSignal } from "../../../signal/organisationSignal";


export default function OrderListOfUser({orders}) {
    const [ordersToDisplay, setOrdersToDisplay] = useState([]);
    const [search, setSearch] = useState("");

    const handleFilters = () => {
        setOrdersToDisplay(orders.filter((item) => {
            if (search === "") return true;
            if (moment(item?.createdAt).format("DD/MM/YY").toLowerCase().includes(search.toLowerCase())) return true;
            if (allUsersSignal.value[item.userId] && allUsersSignal.value[item.userId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (dealerSignal.value[item.dealerId] && dealerSignal.value[item.dealerId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.currentOrderStage.toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.subTotal).toFixed(2).toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.totalAmount).toFixed(2).toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.totalItems.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.userCommissionInPercentage).toFixed(2).toString().toLowerCase().includes(search.toLowerCase())) return true;
            return false;
        }))
    }

    const navigate = useNavigate();

    useEffect(() => {
        handleFilters();
    }, [search, orders])

    const columns = [
        {
            name: "Date",
            center: true,
            selector: "createdAt",
            cell: (row) => `${moment(row?.createdAt).format("DD/MM/YY")}`,
            sortable: true,
        },
        {
            name: "Dealer",
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/orders/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            {(dealerSignal.value[row?.dealerId]?.visitingCard && dealerSignal.value[row?.dealerId]?.visitingCard?.length !== 0) ?
                                <img
                                    style={{ width: "20px", height: "20px" }}
                                    src={dealerSignal.value[row?.dealerId]?.visitingCard[0]?.url}
                                    className="rounded-circle avatar-xs"
                                    alt="friend"
                                />

                                : <>
                                    <Avatar name={dealerSignal.value[row?.dealerId]?.name} size="20" round style={{ borderRadius: "50% !important", width: "20px !important", height: "20px !important", overflow: 'unset' }} />
                                </>}
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {dealerSignal.value[row?.dealerId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{dealerSignal.value[row?.dealerId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Stage",
            center: true,
            selector: (row) => {
                return <Badge onClick={() => navigate(`/dashboard/orders/${row?.id}`)} bg="none" style={{backgroundColor: organisationSignal?.value?.orderStageColors[row?.currentOrderStage]}} text="white">{row?.currentOrderStage}</Badge>
            }
        },
        {
            name: "Subtotal",
            center: true,
            selector: "subTotal",
            cell: (row) => row?.subTotal > 10000 ? `${parseFloat(row?.subTotal / 1000).toFixed(2)}K Rs` : `${parseFloat(row?.subTotal).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Total Amount",
            center: true,
            selector: "totalAmount",
            cell: (row) => row?.totalAmount > 10000 ? `${parseFloat(row?.totalAmount / 1000).toFixed(2)}K Rs` : `${parseFloat(row?.totalAmount).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Total Items",
            center: true,
            selector: "totalItems",
            sortable: true
        },
        {
            name: "Created By",
            center: true,
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/orders/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            <img
                                style={{ width: "20px", height: "20px" }}
                                src={(allUsersSignal.value[row?.userId]?.profileURL === "" || allUsersSignal.value[row?.userId]?.profileURL === undefined) ? avatar1 : allUsersSignal.value[row?.userId]?.profileURL}
                                className="rounded-circle avatar-xs"
                                alt="friend"
                            />
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Employee Commission",
            center: true,
            selector: "userCommissionInPercentage",
            cell: (row) => `${parseFloat(row?.userCommissionInPercentage).toFixed(2)} %`,
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Order List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                </div>
                                {<DataTable
                                    defaultSortAsc={false}
                                    columns={columns}
                                    data={ordersToDisplay}
                                    pagination={true}
                                />}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}